/* eslint-disable import/prefer-default-export */
/* eslint-disable eol-last */
export const MODAL_OPEN = "MODAL_OPEN";
export const MODAL_CLOSE = "MODAL_CLOSE";

export const OPEN_CHOOSE_COUNTRY = "OPEN_CHOOSE_COUNTRY";
export const CLOSE_CHOOSE_COUNTRY = "CLOSE_CHOOSE_COUNTRY";